import { jsxs as i, jsx as e } from "react/jsx-runtime";
function r(t) {
  return /* @__PURE__ */ i("svg", { fill: "currentColor", height: "1em", viewBox: "0 0 24 24", width: "1em", ...t, children: [
    /* @__PURE__ */ e("path", { d: "M0 0h24v24H0z", fill: "none" }),
    /* @__PURE__ */ e("path", { d: "M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" })
  ] });
}
export {
  r as default
};
